export default __webpack_public_path__ + "img/39f4daec9a791a0b41ecb9ff778ecefd.svg";